import axios from "axios";

export function getCmsNetworkClient(token?: string) {
  if (!process.env.NEXT_PUBLIC_CMS_API_URL) {
    console.warn("Can't find process.env.NEXT_PUBLIC_CMS_API_URL");
  }

  const apiClient = axios.create({
    baseURL: process.env.NEXT_PUBLIC_CMS_API_URL,
    headers: {
      "Content-Type": "application/json",
      ...(token && { Authorization: `Token ${token}` }),
    },
  });

  return apiClient;
}
